<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Abogados</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-row class="mt-2 ml-2 mr-2">
            <v-col cols="12" sm="6">
              <v-card outlined elevation="7">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>
                      <b>TOTAL DE ABOGADOS</b>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-chip label color="#24406d" class="white--text text-h6">
                    {{ total }}
                  </v-chip>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card outlined elevation="7">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>
                      <b>ABOGADOS CON PROMOCIONES</b>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-chip label color="#24406d" class="white--text text-h6">
                    {{ con_promocion }}
                  </v-chip>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" class="mb-2">
              <v-card outlined elevation="7">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>
                      <b>ABOGADOS ACTIVOS</b>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-chip label color="#24406d" class="white--text text-h6">
                    {{ activos }}
                  </v-chip>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" class="mb-2">
              <v-card outlined elevation="7">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title>
                      <b>ABOGADOS INACTIVOS</b>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-chip label color="#24406d" class="white--text text-h6">
                    {{ inactivos }}
                  </v-chip>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      total: 0,
      con_promocion: 0,
      activos: 0,
      inactivos: 0
    }
  },
  mounted() {
    this.getEstadisticas();
  },
  methods: {
    getEstadisticas() {
      this.$store.dispatch("GET_ESTADISTICA_ABOGADOS", { url: "/estadisticas/abogados" }).then((response) => {
        this.total = response.total_abogado
        this.con_promocion = response.total_abogados_con_promociones
        this.activos = response.total_abogados_activos
        this.inactivos = response.total_abogados_inactivos
      })
      .catch(err => {
        console.log(err);
      });
    }
  }
}
</script>
<style>
.v-list-item .v-list-item__title, .v-list-item .v-list-item__subtitle {
  white-space: inherit;
}
.v-avatar {
    width: auto !important;
}
</style>
